import * as React from 'react';

class TooltipTemplate extends React.Component {

    render() {
        return (
            <div className="tooltip-p-txt">{this.props.title}</div>
          )
    }
}

export default TooltipTemplate;